export default __webpack_public_path__ + "static/media/waxing-gibbous.f19f5a31.svg";